import { useEffect, useState } from "react";
import { Loader2, Star } from "lucide-react";
import { api } from "@/lib/api";
import { Stars } from "./shared";

export const PartnerEvaluations = ({ partner }) => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    setItems(null);
    api
      .get(`/admin/partners/${partner.id}/evaluations`)
      .then((r) => setItems(r.data))
      .catch(() => setItems([]));
  }, [partner?.id]);

  return (
    <div
      className="mt-4 rounded-xl border border-slate-200 bg-slate-50 p-4"
      data-testid="partner-evaluations"
    >
      <p className="text-[0.65rem] font-semibold uppercase tracking-wider text-slate-400">
        Avaliações por serviço executado
      </p>
      {items === null ? (
        <div className="flex items-center gap-2 py-4 text-sm text-slate-400">
          <Loader2 className="h-4 w-4 animate-spin" />
          Carregando avaliações...
        </div>
      ) : items.length === 0 ? (
        <p className="mt-2 rounded-lg border border-dashed border-slate-200 px-4 py-3 text-sm text-slate-500">
          Ainda sem avaliações. Ao concluir uma demanda, avalie a execução na tela da demanda e
          ela aparece aqui.
        </p>
      ) : (
        <ul className="mt-3 space-y-2">
          {items.map((ev) => (
            <li
              key={ev.lead_id}
              className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-slate-200 bg-white px-4 py-3"
              data-testid={`evaluation-item-${ev.lead_id}`}
            >
              <span className="min-w-0">
                <span className="block truncate text-sm font-semibold text-petrol">
                  {ev.service_type || "Serviço"}
                  <span className="ml-2 font-normal text-slate-400">{ev.city}</span>
                </span>
                {ev.note && (
                  <span className="mt-0.5 block truncate text-xs text-slate-500">{ev.note}</span>
                )}
                <span className="mt-0.5 block font-mono text-[0.62rem] uppercase tracking-wider text-slate-400">
                  {ev.evaluated_at
                    ? new Date(ev.evaluated_at).toLocaleDateString("pt-BR")
                    : ""}
                </span>
              </span>
              <span className="flex shrink-0 items-center gap-2">
                <Stars value={Number(ev.rating)} />
                <span className="inline-flex items-center gap-1 font-display text-sm font-bold text-petrol">
                  <Star className="h-3.5 w-3.5 fill-amber-400 text-amber-400" />
                  {Number(ev.rating).toFixed(1)}
                </span>
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
